// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sliderWrapper":"QlhzI","leftArrow":"mxxpz","removeButtonAnimation":"muMYz","rightArrow":"x85sK","animateLeft":"eE6aS","animateRight":"szIRz","mobileSlider":"GV5Kk"};